module.exports = __webpack_public_path__ + "img/upload-image.6641f3af.png";